
import React from 'react';

interface StatSectionProps {
  title: string;
  stats: {
    matches: number;
    winFt: number;
    drawFt: number;
    lossFt: number;
  };
  totalMatches: number;
  colorScheme: {
    bgColor: string;
    barColor: string;
  };
}

export const StatSection: React.FC<StatSectionProps> = ({
  title,
  stats,
  totalMatches,
  colorScheme
}) => (
  <div className="space-y-2">
    <h3 className="font-medium">{title}</h3>
    <div className="space-y-1">
      <div className="flex justify-between text-sm">
        <span>Win at FT</span>
        <span>{stats.winFt} of {stats.matches} ({((stats.winFt / stats.matches) * 100).toFixed(1)}%) | Overall: {((stats.winFt / totalMatches) * 100).toFixed(1)}%</span>
      </div>
      <div className={`relative h-2 w-full overflow-hidden rounded-full ${colorScheme.bgColor}`}>
        <div 
          className={`h-full ${colorScheme.barColor} transition-all`}
          style={{ width: `${(stats.winFt / stats.matches) * 100}%` }} 
        />
      </div>
      
      <div className="flex justify-between text-sm">
        <span>Draw at FT</span>
        <span>{stats.drawFt} of {stats.matches} ({((stats.drawFt / stats.matches) * 100).toFixed(1)}%) | Overall: {((stats.drawFt / totalMatches) * 100).toFixed(1)}%</span>
      </div>
      <div className={`relative h-2 w-full overflow-hidden rounded-full ${colorScheme.bgColor}`}>
        <div 
          className={`h-full ${colorScheme.barColor} transition-all`}
          style={{ width: `${(stats.drawFt / stats.matches) * 100}%` }} 
        />
      </div>
      
      <div className="flex justify-between text-sm">
        <span>Loss at FT</span>
        <span>{stats.lossFt} of {stats.matches} ({((stats.lossFt / stats.matches) * 100).toFixed(1)}%) | Overall: {((stats.lossFt / totalMatches) * 100).toFixed(1)}%</span>
      </div>
      <div className={`relative h-2 w-full overflow-hidden rounded-full ${colorScheme.bgColor}`}>
        <div 
          className={`h-full ${colorScheme.barColor} transition-all`}
          style={{ width: `${(stats.lossFt / stats.matches) * 100}%` }} 
        />
      </div>
    </div>
  </div>
);
